import type { AdminGetOrganizationLayoutsLayoutResponseDto } from 'app/API';

export type TNormalizedLayouts = {
  data: AdminGetOrganizationLayoutsLayoutResponseDto[];
  count: number;
};

export const normalizeLayoutsResponse = (response: unknown): TNormalizedLayouts => {
  if (Array.isArray(response)) {
    return { data: response, count: response.length };
  }
  const candidate = response as
    | { data?: AdminGetOrganizationLayoutsLayoutResponseDto[]; count?: number }
    | null
    | undefined;
  const data = candidate?.data ?? [];
  return { data, count: candidate?.count ?? data.length };
};
